import { Page } from '@/shared/pagination/page';

export class PageUtil {
  static async getAllPages<T>(f: (currentPage: number) => Promise<Page<T>>): Promise<T[]> {
    const result: T[] = [];
    let currentPage = 0;
    let totalPages = 1;
    do {
      const page = await f(currentPage);

      page.content.forEach(value => result.push(value));

      totalPages = page.totalPages;

      currentPage++;
    } while (currentPage < totalPages);

    return result;
  }
}
